export default __webpack_public_path__ + "static/media/romaine.8fda1b8e.wav";